import gql from 'graphql-tag';

export const BRAND_IMAGE_FRAGMENT = gql`
  fragment BrandImageFragment on BrandImage {
    id
    name
    imageUrl
  }
`;
